import { render, staticRenderFns } from "./ColorContrastWarning.vue?vue&type=template&id=029b94e2&scoped=true&"
import script from "./ColorContrastWarning.vue?vue&type=script&lang=js&"
export * from "./ColorContrastWarning.vue?vue&type=script&lang=js&"
import style0 from "./ColorContrastWarning.vue?vue&type=style&index=0&id=029b94e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029b94e2",
  null
  
)

export default component.exports